/**
 * @prettier
 */
import * as React from 'react';

export function CompletedStepperIcon({ color }: Props): React.ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 0C5.37231 0 0 5.37231 0 12C0 18.6277 5.37231 24 12 24C18.6277 24 24 18.6277 24 12C24 5.37231 18.6277 0 12 0ZM15.7649 9.92246C15.858 9.84286 15.9343 9.74554 15.9894 9.63616C16.0444 9.52678 16.0772 9.40754 16.0857 9.28537C16.0943 9.16321 16.0784 9.04057 16.0391 8.92459C15.9998 8.80861 15.9378 8.70162 15.8567 8.60984C15.7756 8.51807 15.6771 8.44334 15.5668 8.39002C15.4566 8.3367 15.3368 8.30584 15.2146 8.29926C15.0923 8.29267 14.9699 8.31048 14.8546 8.35166C14.7392 8.39283 14.6332 8.45654 14.5428 8.53908C12.8586 10.0247 11.5119 11.8535 10.5932 13.9028L8.96 12.2708C8.78502 12.1077 8.55357 12.0189 8.31443 12.0232C8.07529 12.0274 7.84713 12.1243 7.678 12.2934C7.50888 12.4625 7.412 12.6907 7.40778 12.9298C7.40357 13.169 7.49233 13.4004 7.65539 13.5754L10.2831 16.2043C10.394 16.3151 10.5314 16.3958 10.6822 16.4389C10.8329 16.4819 10.9922 16.4858 11.1449 16.4502C11.2976 16.4146 11.4387 16.3407 11.555 16.2354C11.6712 16.1302 11.7587 15.9971 11.8092 15.8486C12.589 13.5623 13.9526 11.5195 15.7649 9.92246V9.92246Z'
                fill={color}
            />
        </svg>
    );
}

type Props = {
    color: string;
};
